import { useState } from "react";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

import { CustomInput, ReactSelect } from "../../kits/Inputs/Inputs";

export default function PrimaryProductDetail({
  changeFirstTabData,
  data,

  addOrEdit,
}) {
  return (
    <div className="d-flex final-product-detail">
      <div className="w-100 d-flex flex-wrap">
        <div className="col-12 col-sm-3 px-1">
          <CustomInput
            label="قیمت پایه"
            inputSize="lg"
            type="nummber"
            inputContainer=""
            inputClassName=""
            activate={addOrEdit == "edit" ? "disabled" : ""}
            inputValue={addCommas(data.base_price)}
            onChangeFunc={(e) => {
              if (removeCommas(e.target.value)) {
                changeFirstTabData(removeCommas(e.target.value), "base_price");
              }
            }}
            // textErr={validationTxt.answers}
          />
        </div>
      </div>
    </div>
  );
}
